import { Skeleton } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: relative;

  &::before {
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 90%
    );
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

const ListItem = styled.div`
  display: flex;
  padding: var(--spacing-03) 20% var(--spacing-03) var(--layout-02);

  .ant-skeleton {
    margin-right: var(--spacing-03);
  }

  .ant-skeleton-paragraph {
    margin: 0;
  }

  .ant-skeleton-title {
    margin: 0 0 var(--spacing-03);
  }

  .ant-skeleton-content .ant-skeleton-paragraph > li {
    height: 8px;

    &::first-child {
      height: 12px;
    }
  }

  .ant-skeleton-content .ant-skeleton-paragraph > li + li {
    margin-top: var(--spacing-03);
  }
`;

export const ConversationSkeleton: FC = () => {
  return (
    <Wrapper>
      {Array.from(Array(10).keys()).map((value) => {
        return (
          <ListItem key={value}>
            <Skeleton.Avatar shape="square" size="large" />
            <Skeleton paragraph={{ rows: 2 }} />
          </ListItem>
        );
      })}
    </Wrapper>
  );
};
